import {Deserializable} from './deserializable';
import {BaseModel} from './baseModel';


export class AliasRegistrationData implements Deserializable {

  email: string;
  password: string;

  deserialize(input: any) {

    Object.assign(this, input);

    return this;
  }
}
